import { useState as d, useEffect as c } from "react";
function u() {
  const n = "(prefers-reduced-motion: reduce)", [r, t] = d(() => typeof window > "u" || typeof window.matchMedia != "function" ? !1 : window.matchMedia(n).matches);
  return c(() => {
    if (typeof window > "u" || typeof window.matchMedia != "function")
      return;
    const e = window.matchMedia(n);
    t(e.matches);
    const o = (i) => {
      t(i.matches);
    };
    return e.addEventListener("change", o), () => e.removeEventListener("change", o);
  }, []), r;
}
export {
  u as usePrefersReducedMotion
};
